import React from 'react';
import LookupManager from './LookupManager';

const BrandComponent = () => {
    return (
        <LookupManager
            title="Brand"
            endpoint="brands"
            placeholder="Brand name"
            loadingLabel="Loading brands..."
            emptyLabel="No brands yet."
        />
    );
};

export default BrandComponent;
